var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaDoublePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    viewBox: "-10 19.55 359 73.653",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 312.96,
    cy: 48.38,
    r: 26.04,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e42f43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da2d3f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 255.66,
    cy: 48.61,
    r: 26.04,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 198.36,
    cy: 48.61,
    r: 26.04,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 141,
    cy: 48.61,
    r: 26.04,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 83.4,
    cy: 48.61,
    r: 26.04,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 26.04,
    cy: 48.61,
    r: 26.04,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 312.96,
    y1: 22.34,
    x2: 312.96,
    y2: 74.42,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f1a26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8f1a26",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8f1a26",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#8f1a26",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#8f1a26",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8f1a26",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#8f1a26",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#8f1a26",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f1a26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 255.66,
    y1: 22.57,
    x2: 255.66,
    y2: 74.65,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#939392",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#939392",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#939392",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#939392",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#939392",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#939392",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#939392",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939392",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 198.36,
    y1: 22.57,
    x2: 198.36,
    y2: 74.65,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 141,
    y1: 22.57,
    x2: 141,
    y2: 74.65,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 83.4,
    y1: 22.57,
    x2: 83.4,
    y2: 74.65,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 26.04,
    y1: 22.57,
    x2: 26.04,
    y2: 74.65,
    gradientTransform: "matrix(1 0 0 -1 0 94.2)",
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M313 19.78c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 19.78c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.66 19.55c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.66 19.55c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.36 19.55c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.36 19.55c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 19.55c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 19.55c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4 19.55c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4 19.55c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 19.55c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 19.55c14.359 0 26 11.641 26 26s-11.641 26-26 26-26-11.641-26-26 11.641-26 26-26Z",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.23 54.62c-2.07-6.7-1.62-12.6 0-18.81 1.72-.1 3.44-.18 5.16-.25 2.45-.1 4 .91 3.6 4.88a7.352 7.352 0 0 1-1.76 4.33c1.26.58 1.94 2.46 2.11 4.64.36 4.49-1 6-3.84 5.71-1.75-.12-3.5-.35-5.27-.5Zm2.42-14.52a28.872 28.872 0 0 0-.39 3.21h1.6c.77 0 1.34-.56 1.46-1.71.16-1.52-.54-1.55-1.35-1.54Zm-.41 6.73c.06 1.2.19 2.395.39 3.58l1.65.08c.93 0 1.57-.24 1.43-1.72-.14-1.73-1-1.87-2.25-1.91Zm7.85 7.94c.09-6.34 2.32-12.78 4.91-19.28l4.58-.06c1.23 6.49 3.46 13 4.92 19.53H311c-.23-.86-.46-1.72-.68-2.58h-4.69c-.09.85-.15 1.7-.19 2.55Zm6.73-13.45c-.6 2.33-1.13 4.65-1.53 7h3.07c-.58-2.32-1.12-4.69-1.54-7ZM317 55c.35-6.489.35-12.991 0-19.48h4.17c.653 4.939.807 9.93.46 14.9l6.09-.08a44.506 44.506 0 0 1-.83 4.45c-3.24.15-6.57.21-9.89.21Zm11.09-.23a44.912 44.912 0 0 0 .08-19c1.07.06 2.36.2 3.43.28a32.844 32.844 0 0 1 .63 14.05h4.38a29.462 29.462 0 0 1-1.5 4.29c-2.53.2-4.46.22-7.02.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.72 30c-1.33 0-2.55 0-3.72-.07a61.054 61.054 0 0 0-9.27.23h-.28l-.08.28c-1.67 6.72-2.94 15.14-.86 31.25v.4h.74c1.61 0 3.11.09 4.63.09 1.36 0 2.74 0 4.23-.13h.4v-.4c-.08-3.1-.08-6.21-.08-9.26h4.71c4.8-.06 8.39-1.3 10.69-3.69a10.141 10.141 0 0 0 2.6-7.47c-.27-6.77-5.52-11.05-13.71-11.23Zm3.71 10.61a3.293 3.293 0 0 1-.92 2.38 4.74 4.74 0 0 1-3.36 1.24h-3.79c0-1.19.05-2.48.08-3.74 0-1 0-1.9.07-2.79H27c1.65-.02 5.43.24 5.43 2.92ZM83.52 29a16.33 16.33 0 0 0-15.23 10.1A16.167 16.167 0 0 0 67 45.39c.12 9.63 7 16.7 16.49 16.81 9.208.001 16.641-7.523 16.53-16.73-.06-9.083-7.417-16.426-16.5-16.47Zm-5.6 16.41c0-3.9 1.45-8.06 5.53-8.08h.2a4.599 4.599 0 0 1 3.28 1.3c1.42 1.39 2.28 3.93 2.28 6.78 0 3.13-.74 8.39-5.64 8.41-5.25.02-5.65-6.43-5.65-8.39ZM158.82 31h-.3c-2.53-.08-3-.09-5.65-.15h-1.94v.42a57.018 57.018 0 0 1-1.66 16.35c-.69-3.87-1.61-7.38-2.57-11.06-.46-1.79-.94-3.63-1.42-5.6l-.07-.27h-.28a71.206 71.206 0 0 0-7.45 0h-.29l-.07.27c-.6 2.48-1.26 4.76-1.89 7-.93 3.23-1.81 6.3-2.45 9.69a57.117 57.117 0 0 1-1.35-16.44v-.41h-7.49l-.08.3c-2.15 8.13-.26 17.9 6 30.76l.11.21h.23c2.07 0 3.13.07 4.15.07 1.02 0 1.86 0 3.54-.06h.34v-.34c.55-5.6 1.67-11.37 2.77-17 1.12 5.59 2.25 11.36 2.81 17v.36h.36c1.58-.07 3-.07 4.42-.07h4.23l.1-.22c5.57-11.5 7.65-22.32 5.87-30.45Zm37.12 23v-4.11c4.14 0 8.35 0 12.51-.1h.4v-7.92h-.42c-4.1-.1-8.31-.14-12.5-.11V38.1c3.28 0 6.45 0 9.8.14l5 .11h.5l-.08-.49a36.313 36.313 0 0 0-1.93-6.86l-.09-.24h-.25a78.13 78.13 0 0 0-22.13 0h-.32l-.06.29a67.537 67.537 0 0 0 0 29.94l.07.28h.28c3.93.543 7.892.827 11.86.85a85.57 85.57 0 0 0 11.32-.8h.25l.09-.23a25.213 25.213 0 0 0 1.41-7.09v-.48h-.49c-5.03.37-10.16.48-15.22.48Zm74.49 1.1c.45-5.64-1.77-7.08-4.65-8.2a6.86 6.86 0 0 0 4.45-7.22c-.57-6.6-5.14-9.91-14-10.12h-1.72a47.74 47.74 0 0 0-10.41.76h-.24l-.07.23c-3.48 10.34-3.8 21.51-.86 30.66l.07.24h.25c2.311.41 4.653.611 7 .6h2.07v-.43c-.17-3.56-.23-7.21-.28-10.74v-.1h2.75c2 0 3.29.36 4 1.12.9.93 1 2.54 1 4.68a20.658 20.658 0 0 0 .2 5.15l.1.32h.33c1-.07 2-.1 2.93-.13 2.106-.02 4.21-.16 6.3-.42h.3l.3-1.73-.57.1c.042-.384.109-.765.2-1.14.29-1.185.5-2.387.63-3.6ZM260.22 41c.019.294-.018.59-.11.87a2.234 2.234 0 0 1-.45.75c-.65.66-1.94 1-4 1H252c0-1.77 0-3.6.09-5.57 1.45 0 2.92-.06 4.35-.06 2.34.01 3.74 1.11 3.78 3.01Z",
    style: {
      fill: "#101820"
    }
  }), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.935 93.203H.249v-14.49h159.469l-18.783 14.49zm19.722 0h-12.023l18.782-14.49h12.025l-18.784 14.49zm18.784 0h-12.025l18.784-14.49h12.023l-18.782 14.49z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.164 82.303h5.013c2.76 0 3.953 1.599 3.953 4.021 0 2.422-1.238 4.02-3.761 4.02H9.164Zm2.187 6.51h2.432c1.441 0 2.095-.868 2.095-2.567 0-1.487-.632-2.412-2.298-2.412h-2.23Zm15.742-6.734c4.325 0 5.001 2.567 5.001 4.245 0 1.68-.676 4.248-5.001 4.248-4.324 0-5.001-2.568-5.001-4.247 0-1.679.677-4.246 5.001-4.246Zm0 6.959c1.983 0 2.681-1.464 2.681-2.714s-.698-2.715-2.681-2.715c-1.982 0-2.68 1.465-2.68 2.715 0 1.252.697 2.714 2.68 2.714Zm9.154-6.735h2.183v4.618c0 .788.035 2.117 2.039 2.117 2.005 0 2.039-1.328 2.039-2.117v-4.618h2.186v5.158c0 .902-.113 3.11-4.225 3.11-4.112 0-4.222-2.208-4.222-3.11Zm13.05 0h6.036c1.172 0 2.263.541 2.263 2.028 0 .619-.314 1.373-1.068 1.61v.023c.935.157 1.429 1.082 1.429 1.948 0 1.07-.494 2.432-2.928 2.432h-5.732Zm2.184 3.199h3.041c.507 0 .822-.271.822-.868 0-.505-.225-.866-1.126-.866h-2.737Zm0 3.311h3.22c.677 0 .935-.44.935-.947 0-.631-.393-.967-1.16-.967h-2.995Zm10.989-6.51h2.186v6.443h4.899v1.598H62.47Zm11.292 0h7.514v1.531h-5.328v1.668h5.056v1.464h-5.056v1.847h5.373v1.531h-7.559Zm19.248 0h5.406c2.286 0 2.838 1.362 2.838 2.444 0 1.713-.901 2.725-2.669 2.725h-3.39v2.872H93.01Zm2.185 3.706h2.343c.676 0 1.465-.023 1.465-1.105 0-1.047-.642-1.136-1.263-1.136h-2.545Zm10.359-3.706h2.185v6.443h4.899v1.598h-7.084Zm17.07 6.386h-3.694l-.654 1.655h-2.355l3.539-8.041h2.634l3.536 8.041h-2.352Zm-1.848-4.652-1.261 3.188h2.524Zm10.529 3.503-3.56-5.237h2.566l2.084 3.503 2.085-3.503h2.569l-3.559 5.237v2.804h-2.185Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaDoublePlay);
export default __webpack_public_path__ + "static/media/usa_double_play.8c652e69b4e0399ff9799d03561040fd.svg";
export { ForwardRef as ReactComponent };